/** Keep quantity inputs decimal-friendly while rejecting signs and extra dots. */
export function sanitizeQuantity(raw: string): string {
  const cleaned = raw.replace(/[^0-9.]/g, "");
  const dot = cleaned.indexOf(".");
  if (dot === -1) return cleaned;
  return cleaned.slice(0, dot + 1) + cleaned.slice(dot + 1).replace(/\./g, "");
}

export function quantityNumber(raw: string): number {
  const value = Number(raw);
  return Number.isFinite(value) && value >= 0 ? value : 0;
}

/** Step by one without ever producing a negative quantity. */
export function stepQuantity(raw: string, delta: -1 | 1): string {
  return String(Math.max(0, quantityNumber(raw) + delta));
}
